/*
 * Copyright (c) 2019
 *    Reliant Business Valuation, LLC - http://reliantvalue.com
 *    Author: Ronnel Bedana - ronnel@internalvaluation.com
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import * as moment from 'moment';

@Component({
  selector: 'link-expiration',
  templateUrl: 'link-expire.component.html',
  styleUrls: ['link-expire.component.scss'],
})

export class LinkExpireComponent implements OnInit, OnDestroy {

  @Input() created: Date = new Date();
  dateExpiry: Date = new Date();
  expiryDays: any;

  constructor() {
  }

  ngOnInit(): void {
    // const expiry = moment(this.dateExpiry.setDate(new Date(this.created).getDate() + 60));
    this.dateExpiry = new Date(this.created);
    const expiry = moment(this.dateExpiry);
    this.expiryDays = expiry.diff(Date.now(), 'days', false);
  }

  ngOnDestroy(): void {

  }
}
